export default __webpack_public_path__ + "static/media/icon-needs-reply.deac32ba.svg";